module.exports = __webpack_public_path__ + "static/media/try-live-lab.d1abee2e.jpg";